import { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CheckoutContext = createContext();

export function CheckoutProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [source, setSource] = useState(null);

  // `open(source)` logs the click as a lead (best-effort, non-blocking),
  // fires the Meta Pixel `InitiateCheckout` event, and opens the Manual UPI
  // Checkout modal. The WhatsApp redirect is triggered from within the modal
  // itself once the user enters their UTR.
  const open = useCallback((src = 'cta') => {
    const tag = typeof src === 'string' ? src : 'cta';
    setSource(tag);
    setIsOpen(true);

    // Fire-and-forget lead capture
    try {
      axios.post(`${API}/leads`, { source: tag }).catch(() => {});
    } catch (_) {
      // ignore
    }

    // Meta Pixel — InitiateCheckout
    try {
      if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
        window.fbq('track', 'InitiateCheckout', {
          value: 999,
          currency: 'INR',
          content_name: 'DesignCarat 4,000+ STL Bundle',
          content_category: 'digital_bundle',
          source: tag,
        });
      }
    } catch (_) {
      // ignore — never block UX on analytics
    }
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <CheckoutContext.Provider value={{ isOpen, open, close, source }}>
      {children}
    </CheckoutContext.Provider>
  );
}

export function useCheckout() {
  return useContext(CheckoutContext);
}
